import { render, staticRenderFns } from "./PodiumPro.vue?vue&type=template&id=2a2c8193&scoped=true"
import script from "./PodiumPro.vue?vue&type=script&lang=js"
export * from "./PodiumPro.vue?vue&type=script&lang=js"
import style0 from "./PodiumPro.vue?vue&type=style&index=0&id=2a2c8193&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2c8193",
  null
  
)

export default component.exports